module.exports = __webpack_public_path__ + "img/cart.6f54319b.png";